import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';

import { db } from '../firebase/config';
import { ADJUSTABLE_RETENTION, resolveRetentionSettings } from '../config/dataRetention';

const labelFor = (key, value) => (
  ADJUSTABLE_RETENTION.find(config => config.key === key)?.options.find(option => option.value === value)?.label
  || String(value)
);

/**
 * Wirksame Aufbewahrungsfristen für Texte (Datenschutzerklärungen), auch ohne
 * Anmeldung — `appSettings` ist öffentlich lesbar. Bis die Werte geladen sind,
 * gelten die Taxi-Standardwerte.
 */
const useDataRetention = () => {
  const [state, setState] = useState(() => ({
    unternehmensform: 'taxi',
    ...resolveRetentionSettings({}, {}, 'taxi')
  }));

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      getDoc(doc(db, 'appSettings', 'dataRetention')),
      getDoc(doc(db, 'appSettings', 'cloudfunctions')),
      getDoc(doc(db, 'appSettings', 'general'))
    ]).then(([retention, cloudFunctions, general]) => {
      if (cancelled) return;
      const unternehmensform = general.data()?.unternehmensform === 'mietwagen' ? 'mietwagen' : 'taxi';
      setState({
        unternehmensform,
        ...resolveRetentionSettings(retention.data() || {}, cloudFunctions.data() || {}, unternehmensform)
      });
    }).catch((error) => {
      console.error('Aufbewahrungsfristen konnten nicht geladen werden:', error);
    });
    return () => { cancelled = true; };
  }, []);

  return {
    ...state,
    rideLabel: labelFor('rideRetentionDays', state.rideRetentionDays),
    receiptLabel: labelFor('receiptRetentionYears', state.receiptRetentionYears),
    shiftLabel: labelFor('shiftRetentionYears', state.shiftRetentionYears),
    driverTrackLabel: labelFor('driverTrackRetentionDays', state.driverTrackRetentionDays)
  };
};

export default useDataRetention;
